import { __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ApiService, ConfigOauthService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

const SPE_N_OPEN_ACCOUNT = '/spe-n-open-account';
let SpeNOpenAccountProxy = class SpeNOpenAccountProxy {
    constructor(api) {
        this.api = api;
    }
    login(login) {
        const uri = `${SPE_N_OPEN_ACCOUNT}/v1/login/account`;
        return this.api.post(uri, login);
    }
};
SpeNOpenAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNOpenAccountProxy = __decorate([
    Injectable()
], SpeNOpenAccountProxy);

const SPE_N_DEVICE = '/spe-n-device';
const SPE_J_KEYCLOACK = '/spe-j-keycloak';
let SpeNDeviceProxy = class SpeNDeviceProxy {
    constructor(api) {
        this.api = api;
    }
    getExtraheader(headerValue) {
        return [
            { name: 'X-Request-User-Id', value: headerValue },
        ];
    }
    deviceInfo(device, uuidAccountPayment) {
        const uri = `${SPE_N_DEVICE}/v1/login`;
        return this.api.post(uri, device, uuidAccountPayment);
    }
    checkOtp(body) {
        const uri = `${SPE_J_KEYCLOACK}/api/auth/check-otp`;
        return this.api.post(uri, body);
    }
    bioAuth(device, headerValue) {
        const uri = `${SPE_N_DEVICE}/v1/bioauth/login`;
        if (headerValue != '') {
            return this.api.post(uri, device, null, this.getExtraheader(headerValue));
        }
        else {
            return this.api.post(uri, device);
        }
    }
    bioEnroll(device) {
        const uri = `${SPE_N_DEVICE}/v1/bioauth/enroll`;
        return this.api.post(uri, device);
    }
};
SpeNDeviceProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNDeviceProxy = __decorate([
    Injectable()
], SpeNDeviceProxy);

const SPE_N_ACCESS_QRCODE = '/spe-n-access-qrcode';
let SpeNAccessQrCodeProxy = class SpeNAccessQrCodeProxy {
    constructor(api) {
        this.api = api;
    }
    generateQrCode(uuidWhiteLabel, uuidAccountPayment, location) {
        const uri = `${SPE_N_ACCESS_QRCODE}/v1/white-label/${uuidWhiteLabel}/account-payment/${uuidAccountPayment}/generate`;
        return this.api.post(uri, null, null);
    }
    validateAccess(data) {
        const uri = `${SPE_N_ACCESS_QRCODE}/v1/validate`;
        return this.api.post(uri, data);
    }
    checkAccessStatus(data) {
        const uri = `${SPE_N_ACCESS_QRCODE}/v1/check-status`;
        return this.api.post(uri, data);
    }
};
SpeNAccessQrCodeProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNAccessQrCodeProxy = __decorate([
    Injectable()
], SpeNAccessQrCodeProxy);

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

let UiPxLoginModule = class UiPxLoginModule {
};
UiPxLoginModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [SpeNOpenAccountProxy, SpeNDeviceProxy, SpeNAccessQrCodeProxy, ConfigService]
    })
], UiPxLoginModule);

const SPE_EXT_OAUTH = '/spe-ext-oauth';
let SpeExtOauthProxy = class SpeExtOauthProxy {
    constructor(api) {
        this.api = api;
    }
    accessToken(requestToken) {
        const uri = `${SPE_EXT_OAUTH}/oauth2/v1/access-token`;
        return this.api.post(uri, requestToken);
    }
};
SpeExtOauthProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeExtOauthProxy = __decorate([
    Injectable()
], SpeExtOauthProxy);

/*
 * Public API Surface of ui-px-login
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfigService, SpeExtOauthProxy, SpeNAccessQrCodeProxy, SpeNDeviceProxy, SpeNOpenAccountProxy, UiPxLoginModule };
//# sourceMappingURL=wlp-ui-px-login.js.map
